import * as React from "react";
import { AnchoredPanel, AnchoredPanelProps } from "../Panel/AnchoredPanel";
import { ErrorView, ErrorViewProps } from "./ErrorView";

export interface ErrorViewPanelProps extends ErrorViewProps,
  Pick<AnchoredPanelProps, "anchorId" | "componentRef" | "title" | "icon" | "subTitle" | "onClose" | "isOpen"> {
}

/**
 * The ErrorViewPanel handles rendering of AnchoredPanel and ErrorView directly.
 */
export const ErrorViewPanel = ({
  anchorId,
  componentRef,
  title,
  subTitle,
  isOpen,
  onClose,
  icon,
  errorTitle,
  resourceId,
  errorCode,
  details,
}: ErrorViewPanelProps): JSX.Element => (
  <AnchoredPanel
    anchorId={anchorId}
    componentRef={componentRef}
    title={title}
    subTitle={subTitle}
    onClose={onClose}
    icon={icon}
    isOpen={isOpen}
  >
    <ErrorView
      errorTitle={errorTitle}
      resourceId={resourceId}
      errorCode={errorCode}
      details={details}
    />
  </AnchoredPanel>
);
